import React from "react";
import { Modal, DatePicker, InputNumber } from "antd";
import * as Style from "../../../newComponents/styledComponents/styles/ModalStyle";
import moment from "moment";
export const AddOneTimeFunding = ({
  showModal,
  handleChange,
  handleSubmit,
  handleSubmitUpdate,
  onClose,
  formData,
}) => {
  console.log("formadataa", formData);
  return (
    <Modal footer={null} closable={false} visible={showModal} centered>
      <Style.HeaderConatiner>
        <Style.ModalTitle> One-Time Funding</Style.ModalTitle>
      </Style.HeaderConatiner>
      <div
        style={{
          maxHeight: "25rem",
          overflow: "scroll",
        }}
      >
        <div style={{ marginTop: "8px" }}>
          <Style.FieldsTitle>
            Nickname <span style={{ color: "red" }}>*</span>
          </Style.FieldsTitle>

          <Style.Input
            value={formData && formData.nickname}
            name="nickname"
            onChange={(e) => {
              e.preventDefault();
              handleChange(e.target.name, e.target.value);
            }}
            size="large"
            placeholder={`Nickname`}
          ></Style.Input>
        </div>
        <div style={{ marginTop: "8px" }}>
          <Style.FieldsTitle>
            Amount <span style={{ color: "red" }}>*</span>
          </Style.FieldsTitle>
          <div className="inputWrapper" style={{ display: "flex" }}>
            <span
              style={{
                fontSize: "15px",
                padding: "8px",
                display: "flex",
                alignItems: "center",
                color: "rgba(0, 0, 0, 0.65)",
                background: "#fafafa",
                borderRadius: "4px",
                border: "1px solid #d1d5db",
              }}
            >
              $
            </span>
            <InputNumber
              step={1}
              formatter={(value) =>
                `${value}`.replace(/\B(?=(\d{3})+(?!\d))/g, ",")
              }
              parser={(value) => value.replace(/\$\s?|(,*)/g, "")}
              className="Input"
              placeholder="Amount"
              name="amount"
              value={formData && formData.payment}
              id="amount"
              onChange={(value) => {
                handleChange("payment", value);
              }}
            />
          </div>
        </div>

        <div style={{ marginTop: "8px" }}>
          <Style.FieldsTitle>Next funding date</Style.FieldsTitle>
          <DatePicker
            size="large"
            style={{
              width: "100%",
              border: "1px solid #d1d5db",
              borderRadius: "5px",
            }}
            format={"MM-DD-YYYY"}
            placeholder={"Next funding date"}
            value={
              formData && formData.date
                ? moment(formData.date)
                : null
            }
            name="date"
            id="newDate"
            onChange={(date, dateString) => {
              handleChange("date", dateString);
            }}
          />
        </div>
      </div>
      <Style.WrapperButtons>
        <Style.CancelButton
          onClick={() => {
            onClose();
          }}
        >
          Cancel
        </Style.CancelButton>
        <Style.SaveButton
          disabled={!formData || !formData.payment || !formData.nickname}
          onClick={() => {
            if (formData && formData.id) {
              handleSubmitUpdate();
            } else {
              handleSubmit();
            }
          }}
        >
          Save
        </Style.SaveButton>
      </Style.WrapperButtons>
    </Modal>
  );
};
